import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { editAssetAxios, getCategory, getNetwork, userAssetSummit } from "../Actions/v1/user";
import { isEmpty } from "../Actions/commonFunction";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import config from "../config/config";
function VacnewExchange() {
  const location = useLocation();
  const navigate = useNavigate();
  const { account, coinDetail } = useSelector((state) => state.user);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  let initialData = {
    name: "",
    url: "",
    apiurl: "",
    description: "",
    email: "",
    yearofestablish: "",
    supportedcountries: "",
    companyAddress: "",
    feeurl: "",
    tradingfee: "",
    withdrawalfee: "",
    depositefee: "",
    fiat: "",
    paymentmethod: "",
    margintrading: "",
    twitter: "",
    telegram: "",
    facebook: "",
    reddit: "",
    logo: "",
    exchangetype: "",
    type: "",
  };

  const [formData, setFormData] = useState(initialData);
  const [stepform, setStepform] = useState(1);
  const [err, setErr] = useState({});

  const onchangeFunc = (e) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validation = async () => {
    let error = {};
    await Promise.all(
      Object.keys(formData)?.map((val) => {
        if (isEmpty(formData[val])) {
          error[val] = `${val} is required`;
        }
      })
    );
    setErr(error);
    return error;
  };

  const onsummit = async () => {
    let err = await validation();
    if (!isEmpty(err)) return toast.error("Field Required");
    let sendData, resp;
    if (location.pathname == "/editexchange") {
      sendData = {
        _id : location?.state?._id,
        application: { ...formData, mailId: formData?.email },
      };
      resp = await editAssetAxios(sendData);
    } else {
      sendData = {
        emailid:account?.EmailId,
        type: "exchange",
        application: { ...formData, mailId: formData?.email },
      };
      resp = await userAssetSummit(sendData);
    }
    console.log("🚀 ~ onsummit ~ resp:", resp);

    if (resp?.status) {
      toast.success(resp?.message);
      navigate("/");
    } else {
      toast.error(resp?.messge);
    }
  };

  //   useEffect(()=>{
  //     setTimeout(()=>{
  //        if(isEmpty(coinDetail) && (location?.pathname != "editexchange")){
  //          navigate('/vac-verification')
  //        }
  //     },2000)
  //  },[coinDetail])

  useEffect(() => {
    if (location.pathname == "/editexchange") {
      setFormData(location?.state?.application);
    }
  }, [location]);
  //tokenDecimal
  return (
    <div>
      <div>
        <Header />
        <div className="inner_page position-relative pb-5">
          <img src={Images.elogo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-5">
            <div className="vac_border position-relative vac_system rounded-3 py-5 px-4">
              <img src={Images.a1logo} className="a1logo" alt="round" />
              <img src={Images.a2logo} className="a2logo" alt="elogo" />
              <img src={Images.a2logo} className="a3logo" alt="elogo" />
              <Row>
                <Col xl={8} xxl={10} className="mx-auto position-relative">
                  <img
                    src={Images.smallround}
                    className="bot_round"
                    alt="round"
                  />
                  <img
                    src={Images.smallround}
                    className="top_round"
                    alt="round"
                  />
                  <div className="vac_border rounded-3 py-5 px-4">
                    <h4 className="fw-600 text-center">
                      New Exchange Listing Request Form
                    </h4>
                    <p className="text-center">
                      Submit this form to request the listing of your new coin.
                      If you're looking to update existing coin information,
                      kindly use our dedicated form for updates here.
                    </p>

                    {/* <Row>
                      <Col xs={4} sm={4}>
                        <div className="mt-3">
                          <span
                            className={
                              stepform === 1
                                ? "stepborder active"
                                : "stepborder"
                            }
                          ></span>
                          <h6 className="mt-3">Step 1</h6>
                          <p className="mb-0 d-none d-sm-block">
                            Basic Coin Information
                          </p>
                        </div>
                      </Col>
                      <Col xs={4} sm={4}>
                        <div className="mt-3">
                          <span
                            className={
                              stepform === 2
                                ? "stepborder active"
                                : "stepborder"
                            }
                          ></span>
                          <h6 className="mt-3">Step 2</h6>
                          <p className="mb-0 d-none d-sm-block">
                            Supply Information
                          </p>
                        </div>
                      </Col>
                      <Col xs={4} sm={4}>
                        <div className="mt-3">
                          <span
                            className={
                              stepform === 3
                                ? "stepborder active"
                                : "stepborder"
                            }
                          ></span>
                          <h6 className="mt-3">Step 3</h6>
                          <p className="mb-0 d-none d-sm-block">
                            Additional Information
                          </p>
                        </div>
                      </Col>
                    </Row> */}

                    {stepform === 1 && (
                      <>
                        <div className="pt-5">
                          <h4 className="fw-600 text-center">
                            1. Basic Exchange Information
                          </h4>
                          <Row className="form_list">
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Exchange Name{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  onChange={onchangeFunc}
                                  value={formData?.name}
                                  placeholder="Name of the Exchange, e.g. BINANCE"
                                />
                                <p className="mt-2 mb-0 lightclr">
                                  Kindly adhere to the if your asset falls under
                                  one of the following categories:{" "}
                                </p>
                                <p className="mb-0 lightclr">
                                  - Stablecoins, Wrapped Assets, Bridged Assets,
                                  Merged Assets, Tokenized RWA Assets, Synthetic
                                  Assets, Staked Assets/LSTs/LRTs, and Escrowed
                                  Assets
                                </p>
                                {err?.name && <p>{err?.name}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Exchange Site Link{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="url"
                                  onChange={onchangeFunc}
                                  value={formData?.url}
                                  placeholder="Exchange Site URL"
                                />
                              </div>
                              {err?.url && <p>{err?.url}</p>}
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  API Documentaion URL{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="apiurl"
                                  onChange={onchangeFunc}
                                  value={formData?.apiurl}
                                  placeholder="Api Documentaion URL"
                                />
                                <p>
                                  Integration of your exchange can be expedited
                                  if the API is developed based on our API
                                  requirements. For API requirements, kindly
                                  refer to this{" "}
                                  <Link
                                    target="_blank"
                                    className="blueclr"
                                    to={config.docLink}
                                  >
                                    document
                                  </Link>
                                  . Please provide the required endpoints in the
                                  this{" "}
                                  <Link
                                    target="_blank"
                                    className="blueclr"
                                    to={config.formatLink}
                                  >
                                    format
                                  </Link>
                                  .
                                </p>
                                {err?.apiurl && <p>{err?.apiurl}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Description <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="description"
                                  onChange={onchangeFunc}
                                  value={formData?.description}
                                  placeholder="Project Submiter Relation"
                                />
                                {err?.description && <p>{err?.description}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Mail Id <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="email"
                                  onChange={onchangeFunc}
                                  value={formData?.email}
                                  placeholder="Email Id"
                                />
                                <p className="mt-2 mb-0 lightclr">
                                  Login mail Id
                                </p>
                                {err?.email && <p>{err?.email}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Year Of Establish{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="yearofestablish"
                                  value={formData?.yearofestablish}
                                  onChange={onchangeFunc}
                                  placeholder="Year Of Establish"
                                />
                                {err?.yearofestablish && (
                                  <p>{err?.yearofestablish}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Supported Countries{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="supportedcountries"
                                  value={formData?.supportedcountries}
                                  onChange={onchangeFunc}
                                  placeholder="Supported Countries. Eg:india,usa,china"
                                />
                                {err?.supportedcountries && (
                                  <p>{err?.supportedcountries}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Company Address{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <textarea
                                  type="text"
                                  className="form-control"
                                  name="companyAddress"
                                  value={formData?.companyAddress}
                                  onChange={onchangeFunc}
                                  placeholder="companyAddress"
                                />
                                {err?.companyAddress && (
                                  <p>{err?.companyAddress}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Fee Url <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="feeurl"
                                  value={formData?.feeurl}
                                  onChange={onchangeFunc}
                                  placeholder="Fee Url.Eg:https://binance.com/fee"
                                />
                                {err?.feeurl && <p>{err?.feeurl}</p>}
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  Trading Fee <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="tradingfee"
                                  onChange={onchangeFunc}
                                  value={formData?.tradingfee}
                                  placeholder="Trading Fee"
                                />
                                {err?.tradingfee && <p>{err?.tradingfee}</p>}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>
                                  Withdrawal Fee{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Withdrawal Fee"
                                  name="withdrawalfee"
                                  value={formData?.withdrawalfee}
                                  onChange={onchangeFunc}
                                />
                                {err?.withdrawalfee && (
                                  <p>{err?.withdrawalfee}</p>
                                )}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Deposite Fee </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="depositefee"
                                  value={formData?.depositefee}
                                  onChange={onchangeFunc}
                                />
                                {err?.depositefee && <p>{err?.depositefee}</p>}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Fiat Supported </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="fiat"
                                  value={formData?.fiat}
                                  onChange={onchangeFunc}
                                />
                                {err?.fiat && <p>{err?.fiat}</p>}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Payment Method </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="paymentmethod"
                                  value={formData?.paymentmethod}
                                  onChange={onchangeFunc}
                                />
                                {err?.paymentmethod && (
                                  <p>{err?.paymentmethod}</p>
                                )}
                              </div>
                            </Col>
                            <Col lg={6}>
                              <div className="mb-3">
                                <label>Margin Trading</label>
                                <Dropdown
                                  className="reqdrop"
                                  onSelect={(e) => {
                                    onchangeFunc({
                                      target: {
                                        name: "margintrading",
                                        value: e,
                                      },
                                    });
                                  }}
                                >
                                  <Dropdown.Toggle
                                    className="w-100 text-start"
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    {formData?.margintrading == ""
                                      ? "is Enabled Margin Trading"
                                      : formData?.margintrading}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="w-100">
                                    {["Yes", "No"]?.map((val) => (
                                      <Dropdown.Item eventKey={val}>
                                        {val}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                                {err?.margintrading && (
                                  <p>{err?.margintrading}</p>
                                )}
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="mb-3">
                                <label>Exchange Type</label>
                                <Dropdown
                                  className="reqdrop"
                                  onSelect={(e) => {
                                    onchangeFunc({
                                      target: {
                                        name: "exchangetype",
                                        value: e,
                                      },
                                    });
                                  }}
                                >
                                  <Dropdown.Toggle
                                    className="w-100 text-start"
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    {formData?.exchangetype == ""
                                      ? "Select Exchange Type"
                                      : formData?.exchangetype}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="w-100">
                                    {["CEX", "DEX"]?.map((val) => (
                                      <Dropdown.Item eventKey={val}>
                                        {val}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                                {err?.exchangetype && (
                                  <p>{err?.exchangetype}</p>
                                )}
                              </div>
                            </Col>

                            <Col lg={6}>
                              <div className="mb-3">
                                <label>Type</label>
                                <Dropdown
                                  className="reqdrop"
                                  onSelect={(e) => {
                                    onchangeFunc({
                                      target: {
                                        name: "type",
                                        value: e,
                                      },
                                    });
                                  }}
                                >
                                  <Dropdown.Toggle
                                    className="w-100 text-start"
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    {formData?.type == ""
                                      ? "Select Type"
                                      : formData?.type}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="w-100">
                                    {["spot", "derivatives"]?.map((val) => (
                                      <Dropdown.Item eventKey={val}>
                                        {val.toUpperCase()}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                                {err?.type && <p>{err?.type}</p>}
                              </div>
                            </Col>
                            {/* <Col lg={6}>
                              <div className="mb-3">
                                <label>Network</label>
                                <Dropdown
                                  className="reqdrop"
                                  onSelect={(e) => {
                                    onchangeFunc({
                                      target: { name: "network", value: e.id ,data : e.data},
                                    });
                                  }}
                                >
                                  <Dropdown.Toggle
                                    className="w-100 text-start"
                                    variant="success"
                                    id="dropdown-basic"
                                  >
                                    {selNetwork == "" ? "Select Network" : selNetwork}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="w-100">
                                    {networklist?.map((val) => (
                                      <Dropdown.Item eventKey={{id : val?._id , data : val.name}}>
                                        {val?.name}
                                      </Dropdown.Item>
                                    ))}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </Col> */}
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Twitter </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="twitter"
                                  value={formData?.twitter}
                                  onChange={onchangeFunc}
                                />
                                {err?.twitter && <p>{err?.twitter}</p>}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <label>Telegram </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="telegram"
                                  value={formData?.telegram}
                                  onChange={onchangeFunc}
                                />
                                {err?.telegram && <p>{err?.telegram}</p>}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <label>Face Book </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="facebook"
                                  value={formData?.facebook}
                                  onChange={onchangeFunc}
                                />
                                {err?.facebook && <p>{err?.facebook}</p>}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <label>Reddit</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                  name="reddit"
                                  value={formData?.reddit}
                                  onChange={onchangeFunc}
                                />
                                {err?.reddit && <p>{err?.reddit}</p>}
                              </div>
                            </Col>

                            <Col md={6}>
                              <div className="mb-3">
                                <label>logo(URL)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="URL. Eg: https://cryptologos.cc/logos/bnb-bnb-logo.png"
                                  name="logo"
                                  value={formData?.logo}
                                  onChange={onchangeFunc}
                                />
                                {err?.logo && <p>{err?.logo}</p>}
                              </div>
                            </Col>
                          </Row>
                        </div>

                        <hr className="reqhr"></hr>

                        {/* <div className="pt-3">
                          <h4 className="fw-600 text-center">
                            2. Project Information
                          </h4>
                          <p className="text-center">
                            Please provide a clear and concise description of
                            the project written in the third person.
                            Descriptions that are vague, “shilly” or written in
                            the first person (i.e.Our project is the best AMM in
                            the world) will result in listing DELAYS and/or
                            REJECTION.
                          </p>
                          <Row className="form_list pt-2">
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  What is the project about?{" "}
                                  <span className="redclr">*</span>
                                </label>
                                <textarea
                                  rows={4}
                                  className="form-control"
                                ></textarea>
                                <p className="lightclr mt-1">
                                  Please provide a clear and concise description
                                  of the project (eg. purpose, function, utility
                                  etc). Vague or "shilly" description will
                                  result in listing DELAYS and/or REJECTION.
                                  Minimum 400 characters.
                                </p>
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>What makes your project unique? </label>
                                <textarea
                                  rows={4}
                                  className="form-control"
                                ></textarea>
                                <p className="lightclr mt-1">
                                  Please provide a clear and concise description
                                  of the project (eg. purpose, function, utility
                                  etc). Vague or "shilly" description will
                                  result in listing DELAYS and/or REJECTION.
                                  Minimum 400 characters.
                                </p>
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>History of your project? </label>
                                <textarea
                                  rows={4}
                                  className="form-control"
                                ></textarea>
                                <p className="lightclr mt-1">
                                  Please provide a clear and concise description
                                  of the project (eg. purpose, function, utility
                                  etc). Vague or "shilly" description will
                                  result in listing DELAYS and/or REJECTION.
                                  Minimum 400 characters.
                                </p>
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>What's next for your project?</label>
                                <textarea
                                  rows={4}
                                  className="form-control"
                                ></textarea>
                                <p className="lightclr mt-1">
                                  Please provide a clear and concise description
                                  of the project (eg. purpose, function, utility
                                  etc). Vague or "shilly" description will
                                  result in listing DELAYS and/or REJECTION.
                                  Minimum 400 characters.
                                </p>
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>
                                  What can your coin/token be used for?
                                </label>
                                <textarea
                                  rows={4}
                                  className="form-control"
                                ></textarea>
                                <p className="lightclr mt-1">
                                  Please provide a clear and concise description
                                  of the project (eg. purpose, function, utility
                                  etc). Vague or "shilly" description will
                                  result in listing DELAYS and/or REJECTION.
                                  Minimum 400 characters.
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>

                        <hr className="reqhr"></hr>

                        <div className="pt-3">
                          <h4 className="fw-600 text-center">
                            3. Exchange Trading Information
                          </h4>
                          <p className="text-center">
                            IMPORTANT NOTE: Please provide the EXACT LINK to the
                            market pairs. Failure to properly link to exchange
                            pairs may result in LISTING DELAYS.
                          </p>
                          <Row className="form_list">
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>Exchange Trade URL</label>
                                <textarea
                                  rows={4}
                                  className="form-control"
                                ></textarea>
                              </div>
                            </Col>
                          </Row>
                        </div>

                        <hr className="reqhr"></hr>

                        <div className="pt-3">
                          <h4 className="fw-600 text-center">
                            4. Block Explorer Links
                          </h4>
                          <p className="text-center">
                            Lorem ipsum is a dummy or placeholder text commonly
                            used in graphic design, publishing, and web
                            development to fill empty spaces in a layout that
                            does not yet have content.
                          </p>
                          <Row className="form_list">
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>Explorer Link</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>Explorer Link (2)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>Explorer Link (3)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>Explorer Link (4)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col lg={12}>
                              <div className="mb-3">
                                <label>Explorer Link (5)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>

                        <hr className="reqhr"></hr>

                        <div className="pt-3">
                          <h4 className="fw-600 text-center">
                            5. Block Information
                          </h4>
                          <p className="text-center">
                            Please provide explorer link(s) of the token. For
                            example, if this is an ERC20 token please provide
                            the Etherscan URL.
                          </p>
                          <Row className="form_list">
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Block Reward</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="mb-3">
                                <label>Block Time/Transaction Speed(Ms)</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder=""
                                />
                              </div>
                            </Col>
                          </Row>
                        </div> */}

                        <div className="d-flex mt-3">
                          <button
                            className="clearbtn py-2 me-3"
                            onClick={() => setFormData({})}
                          >
                            Clear Form
                          </button>
                          <button
                            className="themebtn py-2"
                            onClick={() => onsummit()}
                          >
                            Submit
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default VacnewExchange;
